import React, { useState } from 'react';

interface OnboardingInterface {
  analyticsSource: string;
}

const OnboardingContext = React.createContext<OnboardingInterface>({
  analyticsSource: '',
});

type ProviderProps = {
  analyticsSource: string;
  children: any;
};

export const OnboardingContextProvider = (
  props: ProviderProps
): JSX.Element => {
  const [analyticsSource] = useState(props.analyticsSource);

  return (
    <OnboardingContext.Provider
      value={{
        analyticsSource,
      }}
    >
      {props.children}
    </OnboardingContext.Provider>
  );
};
export default OnboardingContext;
